import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import Slider from 'react-slick'
import InvestorsConfetti from './investors.confetti';
import {
  InvestorSectionCarousel,
  InvestorSectionCarouselItem,
  InvestorSection,
  InvestorContainer,
  InvestorSectionWrapper
} from './investors.styles';


const Investors = (): JSX.Element => {

  // TODO: Move this image query to API https://mightynetworks.atlassian.net/browse/MNW-271
  const investorLogoImages: any = useStaticQuery(graphql`{
  floodgate: file(relativePath: {eq: "floodgate.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
  grayowlventures: file(relativePath: {eq: "grayowlventures.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
  ziffcapital: file(relativePath: {eq: "ziffcapital.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
  intel: file(relativePath: {eq: "intel.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
  lucas: file(relativePath: {eq: "lucas.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
  liontree: file(relativePath: {eq: "liontree.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
  greatoaks: file(relativePath: {eq: "greatoaks.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
  bbg: file(relativePath: {eq: "bbg.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
  firstround: file(relativePath: {eq: "firstround.png"}) {
    childImageSharp {
      gatsbyImageData(width: 164, layout: FIXED, placeholder: BLURRED)
    }
  }
}
`)

  const sliderSettings = {
    infinite: true,
    draggable: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <svg xmlns="http://www.w3.org/2000/svg" width="29" version="1.1" x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" spacing="preserve"><path fill="#191F28" d="M361.891,242.03L187.347,9.31c-7.714-10.283-22.298-12.365-32.582-4.655 c-10.283,7.713-12.367,22.3-4.655,32.582l164.072,218.758L150.111,474.762c-7.713,10.282-5.627,24.871,4.655,32.582 c4.186,3.14,9.086,4.656,13.945,4.656c7.076,0,14.064-3.215,18.637-9.311l174.544-232.732 C368.097,261.683,368.097,250.304,361.891,242.03z" /></svg>,
    prevArrow: <svg xmlns="http://www.w3.org/2000/svg" width="29" enableBackground="new 0 0 512 512" version="1.1" viewBox="0 0 512 512"><path d="m150.11 242.03 174.54-232.72c7.714-10.283 22.298-12.365 32.582-4.655 10.283 7.713 12.367 22.3 4.655 32.582l-164.07 218.76 164.07 218.77c7.713 10.282 5.627 24.871-4.655 32.582-4.186 3.14-9.086 4.656-13.945 4.656-7.076 0-14.064-3.215-18.637-9.311l-174.54-232.73c-6.205-8.274-6.205-19.653 1e-3 -27.927z" fill="#191F28" /></svg>,
    responsive: [
      {
        breakpoint: 950, // layout.subLg
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 800, // layout.subMd
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 700, // layout.sm
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 500, // layout.xs
        settings: {
          slidesToShow: 1
        }
      }
    ],
  }

  return (
    <InvestorSectionWrapper>
      <InvestorContainer>
        <FadeInAnimationWrapper>
          <InvestorSection>
            <InvestorsConfetti />
            <Heading
              text="Backed by investors equally passionate about your success"
              size="2.5em"
              sizeLg="2em"
              sizeSubLg="1.5em"
              align="center"
            />
            <InvestorSectionCarousel>
              <Slider {...sliderSettings}>
                {
                  Object.keys(investorLogoImages).map((key) => investorLogoImages[ key ] !== null && (
                    <InvestorSectionCarouselItem key={key}>
                      <div>
                        <Image childImageSharp={investorLogoImages[ key ].childImageSharp.gatsbyImageData} alt={key} />
                      </div>
                    </InvestorSectionCarouselItem>
                  ))
                }
              </Slider>
            </InvestorSectionCarousel>
          </InvestorSection>
        </FadeInAnimationWrapper>
      </InvestorContainer>
    </InvestorSectionWrapper>
  )
}

export default Investors;
